import { ChatHistoryPanel } from "../ChatHistory";

interface Props {
    onNewClick: () => void;
    newDisabled?: boolean;
    onHistoryClick: () => void;
}

export const Sidebar = ({ onNewClick, newDisabled, onHistoryClick }: Props) => {
    return (
        <nav className={"flex h-full w-full flex-col px-3 pb-0"}>
            <div className="flex self-start items-center overflow-hidden gap-3 h-14">
                <button
                    className={
                        "flex w-32 justify-center rounded-lg px-3 py-1.5 text-sm font-bold leading-6" +
                        (newDisabled
                            ? " text-j-light-grey bg-j-super-light-grey cursor-default"
                            : " text-j-dark bg-gradient-to-r from-j-green to-j-cyan cursor-pointer hover:from-j-green-hover hover:to-j-cyan-hover")
                    }
                    onClick={onNewClick}
                >
                    <span>New chat</span>
                </button>
                <button
                    className="flex w-32 justify-center rounded-lg bg-j-dark px-3 py-1.5 text-sm font-bold leading-6 text-j-white border-solid border-2 border-j-green hover:bg-j-dark-hover"
                    onClick={onHistoryClick}
                >
                    <span>Hide history</span>
                </button>
            </div>
            <div className="flex-col flex-1 transition-opacity duration-500 -mr-2 pr-2 overflow-y-auto overflow-x-hidden">
                <div className="flex flex-col gap-2 pb-2 text-sm">
                    <ChatHistoryPanel />
                </div>
            </div>
        </nav>
    );
};
